import React, { Fragment } from "react";
import GenericHeader from "../../common/Header";

class HeaderLayout extends React.Component {
  state = {};
  constructor() {
    super();
    this.headerLayout = [
      {
        label: {
          value: "Item",
          size: "50%",
          maxWidth: "150px"
        },
        item: {
          node: "input", //filter
          type: "string",
          value: "",
          intemName: "itemNumber",
          autoFocus: true,
          onBlur: "lookup",
          hotMod: false,
        },
        size: "15%"
      },
      {
        label: {
          value: "Description",
          size: "50%",
          maxWidth: "140px"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "description"
        },
        readOnly: true,
        size: "27%"
      },
      {
        label: {
          value: "Line",
          size: "50%",
          maxWidth: "150px"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "lineCode"
        },
        readOnly: true,
        size: "12.5%"
      },
      {
        label: {
          value: "Part",
          size: "53%",
          maxWidth: "140px"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "partNumber"
        },
        readOnly: true,
        size: "8.5%"
      },
      {
        label: {
          value: "Warehouses"
        },
        item: {
          node: "DCSelector",
          value: "",
          onChange: "lookup",
          intemName: "wse"
        },
        size: "37%"
      },

      {
        label: {
          value: "Model Item", /////////////ESTE////////////////////////////////////////
          size: "50%",
          maxWidth: "150px"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "modelItem"
        },
        size: "15%",
        readOnly: true
      },
      {
        label: {
          value: "Model Warehouse", /////////////ESTE OTRO////////////////////////////////
          size: "76%",
          maxWidth: "150px"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "modelWarehouse"
        },
        size: "16%",
        readOnly: true
      },
      {
        label: {
          value: "Average Cost",
          size: "70%",
          maxWidth: "120px"
        },
        item: {
          node: "input",
          type: "number",
          value: "",
          intemName: "currentCostBase"
        },
        readOnly: true,
        size: "14%"
      },
      {
        label: {
          value: "Average Core",
          size: "70%",
          maxWidth: "150px"
        },
        item: {
          node: "input",
          type: "number",
          value: "",
          intemName: "currentCostCore"
        },
        readOnly: true,
        size: "12.5%"
      },
      {
        label: {
          value: "LIFO Pool",
          size: "53%",
          maxWidth: "150px"
        },
        item: {
          node: "input",
          filter: "[^609]",
          type: "string",
          value: "",
          intemName: "lifoPool",
          onBlur: "checkLifoPool",
          maxLength: 3
        },
        readOnly: true,
        size: "12.5%"
      },
      {
        label: {
          value: "LIFO Cost",
          size: "65%",
          maxWidth: "150px"
        },
        item: {
          node: "input",
          type: "number",
          value: "",
          intemName: "lifoCost"
        },
        readOnly: true,
        size: "12%"
      },
      {
        label: {
          value: "Net NIPO + Core",
          size: "137px"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "netNipoCore"
        },
        readOnly: true,
        size: "18%"
      },
      {
        label: {
          value: "Sub Item",
          size: "50%",
          maxWidth: "150px"
        },
        item: {
          node: "input",
          type: "number",
          value: "",
          intemName: "subItem"
        },
        size: "15%"
      },
      {
        label: {
          value: "Sub Type",
          size: "55%",
          maxWidth: "150px"
        },
        item: {
          node: "input",
          type: "number",
          value: "",
          filter: "[^12450]" /* only allow N n->N or ' ' */,
          maxLength: 1,
          intemName: "subType"
        },
        size: "11.3%"
      },
      {
        label: {
          value: "Item Status",
          size: "68%",
          maxWidth: "150px",
          fontSize: "92%"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          filter: "[^NnSsRrCcDdTtQqGgCcXx ]",
          forceCaps: true,
          maxLength: 1,
          intemName: "itemStatus"
        },
        size: "10%"
      },
      {
        label: {
          value: "Date",
          size: "67px"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "itemStatusDate"
        },
        size: "15%",
        readOnly: true
      },
      {
        label: {
          value: "Core Retail",
          size: "83px",
          fontSize: "86%"
        },
        item: {
          node: "input",
          type: "number",
          value: "",
          intemName: "coreRetail"
        },
        readOnly: true,
        size: "12.8%"
      },
      {
        label: {
          value: "Pending Core Retail^",
          size: "182px"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "corePendRetail"
        },
        readOnly: true,
        size: "17.9%"
      },
      {
        label: {
          value: "Pending Date",
          size: "137px"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "corePendDate"
        },
        readOnly: true,
        size: "18%"
      }
    ];
  }
  componentDidMount() {
    this.setState({ layout: this.headerLayout });
  }

  formatData = props => {
    if (props) {
      this.headerLayout.map((layout, key) => {
        if (layout.item.intemName === props[key].name) {
          layout.item.value =
            props[key].value === undefined ||
            props[key].value === "" ||
            props[key].value === false
              ? ""
              : props[key].value;
          layout.item.span = props[key].span;
          layout.label.value = props[key].label;
        }
        return null;
      });
    }

    return null;
  };
  getHeaderInfo = info => {
    this.props.setHeaderInfo({ header: info });
  };
  renderHeader = () => {
    this.formatData(this.props.headerData);
    return (
      <GenericHeader
        jsonObj={this.state.layout}
        setHeaderInfo={this.getHeaderInfo}
        functions={{
          lookup: this.props.lookup,
          checkVendor: this.props.checkVendor,
          checkLifoPool: this.props.checkLifoPool,
          setErrorMessage: this.props.setErrorMessage,
          setSuccessMessage: this.props.setSuccessMessage,
          validateDate: this.props.validateDate,
          handeOpenModal: this.props.handeOpenModal,
          closeModal: this.props.closeModal
        }}
      />
    );
  };
  render() {
    return <Fragment>{this.renderHeader()}</Fragment>;
  }
}
export default HeaderLayout;
